import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { getImageUrl } from '@/lib/image-url';

export interface SiteImage {
  id: string;
  section: string;
  key: string;
  url: string;
  alt: string;
  order: number;
}

export function useSiteImages(section: string) {
  const [images, setImages] = useState<SiteImage[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    supabase
      .from('site_images')
      .select('*')
      .eq('section', section)
      .order('order', { ascending: true })
      .then(({ data }) => {
        if (!cancelled && data) {
          setImages(
            data.map((row) => ({
              ...row,
              url: getImageUrl(row.url),
            }))
          );
        }
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [section]);

  return { images, loading };
}
